import { ChangeDetectionStrategy, Component, Inject, PLATFORM_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  title = 'drparagdesignerbodyz';

  constructor(private router: Router, @Inject(PLATFORM_ID) private platformId: Object) {}

 ngOnInit(): void {
   // Ensure platform-specific logic only runs in the browser
   if (isPlatformBrowser(this.platformId)) {
    // Subscribe to router events and trigger actions on navigation end
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.loadFonts();
        if (typeof window !== 'undefined') {
          window.scrollTo(0, 0); // Scroll to top on route change
        }
      }
    });
  }
  }

  loadFonts() {
    // SSR-safe document access
    if (typeof document !== 'undefined') {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Crimson+Text:wght@400;600;700&display=swap';
      document.head.appendChild(link);
    }
  }

}
